import { render, staticRenderFns } from "./OrderDetailScatterChart.vue?vue&type=template&id=c06ffd50&"
import script from "./OrderDetailScatterChart.vue?vue&type=script&lang=ts&"
export * from "./OrderDetailScatterChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports